module.exports = __webpack_public_path__ + "static/importe-baed82a4ecc8f76f60d8ae61b2ffe6d1.png";